var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup"},[_c('div',{staticClass:"popup__wrap"},[_c('div',{staticClass:"popup__title"},[_vm._v(_vm._s(_vm.title))]),_c(_vm.popupContent,{tag:"component",attrs:{"payload":_vm.payload,"close":_vm.closePopup}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }